import { Provider } from "react-redux";
//
import AppStore from "@/app-store";
import AppRoutes from "./app-routes";

const App = () => {

    return (
        <Provider store={AppStore}>
            <div className="App" id="scroll">
                <AppRoutes />
            </div>
        </Provider>
    );
    
}

export default App;
